import { Endpoint } from "../config";

export type RolesEndpointType =
  | "roles"
  | "createRole"
  | "updateRole"
  | "deleteRole"
  | "getRoleById"
  | "fetchallpermissions"
  | "assignRole"
  | "fetchAllRoles";

export const rolesEndpoints: Record<RolesEndpointType, Endpoint> = {
  roles: {
    url: "tenant-role/",
  },
  fetchAllRoles: {
    url: "select-role/",
  },
  createRole: {
    url: "tenant-role/",
  },
  updateRole: {
    url: "tenant-role/[role_id]/",
  },
  deleteRole: {
    url: "tenant-role/[role_id]/",
  },
  getRoleById: {
    url: "tenant-role/[role_id]/",
  },
  fetchallpermissions: {
    url: "select-permission/",
  },
  assignRole: {
    url: "tenant-role/assign/",
  },
};
